class CopyCouponCode extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.label = this.querySelector('.zumii-offer-carousel__copy-label');
    if (!this.button) return;
    this.defaultLabel = this.label ? this.label.textContent : '';
    this.copiedLabel = this.getAttribute('data-copied-label') || this.defaultLabel;
    this.button.addEventListener('click', this.copyCode.bind(this));
  }

  copyCode() {
    const code = this.getAttribute('data-code');
    if (!code) return;

    const markCopied = () => {
      this.setAttribute('data-copied', 'true');
      if (this.label) this.label.textContent = this.copiedLabel;
      window.clearTimeout(this.resetTimeout);
      this.resetTimeout = window.setTimeout(() => {
        this.removeAttribute('data-copied');
        if (this.label) this.label.textContent = this.defaultLabel;
      }, 2500);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(markCopied).catch(() => this.fallbackCopy(code, markCopied));
    } else {
      this.fallbackCopy(code, markCopied);
    }
  }

  fallbackCopy(code, onSuccess) {
    const textarea = document.createElement('textarea');
    textarea.value = code;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      onSuccess();
    } catch (error) {
      // Clipboard access unavailable; the code remains visible for manual copy.
    }
    document.body.removeChild(textarea);
  }
}

customElements.define('copy-coupon-code', CopyCouponCode);
